export default __webpack_public_path__ + "static/media/10-100.1615ded8.jpg";